import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';

export function inventoryAdjustmentStart({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory Adjustment Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}

export function inventoryAdjustmentCreate({ adjustment, outlet }) {
  const clevertapData = {
    'Outlet Name': outlet.name,
  };
  let namespace;
  if (adjustment.hasOwnProperty('history_details')) {
    namespace = 'items';
    clevertapData['List of Items'] = adjustment.history_details.map(d => ({
      Name: d.item_name,
      Variant: d.item_variant_name,
      'Previous Qty': d.beginning_stock,
      'New Qty': d.quantity,
    }));
  } else {
    clevertapData[
      'List of Ingredients'
    ] = adjustment.ingredient_history_details.map(d => ({
      Name: d.ingredient_name,
      'Previous Qty': d.beginning_stock,
      'New Qty': d.quantity,
    }));
    namespace = 'ingredients';
  }
  clevertapData['Current Inventory Filter'] = namespace;
  pushClevertapEvent('Inventory Adjustment Create', clevertapData);
}

export function inventoryAdjustmentExport({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  const clevertapData = {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  };
  pushClevertapEvent('Inventory Adjustment Export', clevertapData);
}

export function inventoryAdjustmentImport({ namespace }) {
  pushClevertapEvent('Inventory Adjustment Import', {
    'Current Inventory Filter': namespace,
  });
}

export function inventoryAdjustmentImportSuccess({ outletId }) {
  pushClevertapEvent('Inventory Adjustment Import Success', {
    'Outlet Id': outletId,
  });
}

export function inventoryAdjustmentImportFailed({ outletId }) {
  pushClevertapEvent('Inventory Adjustment Import Failed', {
    'Outlet Id': outletId,
  });
}
